




























import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { InitialFilterParameter } from ".";
import { JapaneseCharacter } from "../../../domain/system";

@Component
export default class InitialFilter extends Mixins(ModelEditableMixin) {
  editingSource: InitialFilterParameter;

  @Prop({ default: false })
  isMaintenance: boolean;

  data(): any {
    return {
      firstInitialCharacters: JapaneseCharacter.headCharacters,
    };
  }
  firstInitialCharacters: string[];

  get selectedFirstInitialCharacter(): string {
    if (!this.editingSource.keyword || this.editingSource.keyword.length === 0) { return null; }
    if (this.editingSource.keyword.length === 1) {
      return JapaneseCharacter.getHeadCharacter(this.editingSource.keyword);
    } else {
      const splitted = this.editingSource.keyword.split("");
      return splitted[0];
    }
  }
  
  get selectedSecondInitialCharacter(): string {
    if (!this.editingSource.keyword || this.editingSource.keyword.length !== 1) { return null; }
    return this.editingSource.keyword;
  }

  get secondInitialCharacters(): string[] {
    return JapaneseCharacter.getColumnCharacters(this.selectedFirstInitialCharacter);
  }

  getFirstInitialCharacterButtonClass(character: string): string {
    return (character === this.selectedFirstInitialCharacter) ? "selected" : undefined;
  }

  getSecondInitialCharacterButtonClass(character: string): string {
    return (character === this.selectedSecondInitialCharacter) ? "selected" : undefined;
  }

  changeFirstInitialCharacter(character: string): void {
    this.writeProperty((p: InitialFilterParameter) => {
      p.keyword = JapaneseCharacter.getColumnCharacters(character).join();
    });
  }

  changeSecondInitialCharacter(character: string): void {
    this.writeProperty((p: InitialFilterParameter) => {
      p.keyword = character;
    });
  }

  clearSelectedInitialCharacter(): void {
    this.writeProperty((p: InitialFilterParameter) => {
      p.keyword = null;
    });
  }

  get initialFilterRootClassName(): string {
    return this.isMaintenance
      ? "maintenance"
      : "";
  }
}
